// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a70655c2","359":"2388a17d","494":"1d426703","512":"6a00230c","553":"c6f71329","667":"984d73fa","695":"ea37b44f","701":"c1c96a4f","713":"acebf6c2","771":"0e3253ad","977":"3d95272e"}[chunkId] + ".chunk.js";
};